import formatClientErrorData from 'src/common/utils/formatClientErrorData';

export default function apiClientEffectsErrorCallback(tuneInApiClient) {
  return (error, actionType) => {
    const errorData = formatClientErrorData({
      message: 'client apiClientEffectsMiddleware fetch error',
      context: {
        error,
        actionType,
      },
    });

    tuneInApiClient?.logging?.errorLog(errorData);
  };
}
